module.exports = __webpack_public_path__ + "static/media/crypto-meditation.447fea1c.svg";